export default function addSnapshotData(results, snapshotState) {

    results.testResults.forEach((params) => {
        if (params.status === 'pending' || params.status === 'failed') {
            // if test is skipped or failed, we don't want to mark
            // its snapshots as obsolete.
            snapshotState.markSnapshotsAsCheckedForTest(params.fullName);
        }
    });

    const uncheckedCount = snapshotState.getUncheckedCount();
    const uncheckedKeys = snapshotState.getUncheckedKeys();

    if (uncheckedCount) {
        snapshotState.removeUncheckedKeys();
    }

    const status = snapshotState.save();

    results.snapshot.fileDeleted = status.deleted;
    results.snapshot.added = snapshotState.added;
    results.snapshot.matched = snapshotState.matched;
    results.snapshot.unmatched = snapshotState.unmatched;
    results.snapshot.updated = snapshotState.updated;
    results.snapshot.unchecked = !status.deleted ? uncheckedCount : 0; // Copy the array to prevent memory leaks

    results.snapshot.uncheckedKeys = Array.from(uncheckedKeys);

    return results;
}
